import { Link } from 'react-router-dom';
import './ContentPage.css';

const Terms = () => (
  <main className="content-page">
    <div className="content-page__container">
      <nav className="content-crumbs" aria-label="Хлебные крошки">
        <Link to="/">Главная</Link>
        <span aria-hidden="true">/</span>
        <span>Пользовательское соглашение</span>
      </nav>

      <header className="content-page__header">
        <h1 className="content-page__title">Пользовательское соглашение</h1>
        <p className="content-page__lead">
          Условия использования сайта ЕнотМани и правила работы с материалами сервиса.
        </p>
      </header>

      <article className="content-panel legal-text">
        <h2>1. Предмет соглашения</h2>
        <p>
          1.1. Настоящее соглашение определяет условия использования сайта ЕнотМани, включая каталоги продуктов,
          статьи и информационные материалы.
        </p>
        <p>
          1.2. Используя сайт, вы подтверждаете согласие с условиями соглашения и политикой конфиденциальности.
        </p>

        <h2>2. Характер информации</h2>
        <p>
          2.1. Материалы сайта носят справочный характер и не являются публичной офертой, индивидуальной
          финансовой рекомендацией или гарантией одобрения заявки.
        </p>
        <p>
          2.2. Актуальные ставки, тарифы и требования определяются банком или компанией на момент оформления.
        </p>

        <h2>3. Обязанности пользователя</h2>
        <ul>
          <li>использовать сайт добросовестно и в рамках закона;</li>
          <li>не пытаться нарушить работу сервиса;</li>
          <li>самостоятельно проверять условия продукта перед оформлением;</li>
          <li>не передавать третьим лицам доступы и коды подтверждения.</li>
        </ul>

        <h2>4. Интеллектуальная собственность</h2>
        <p>
          4.1. Дизайн, тексты, структура и иные материалы сайта охраняются законом. Копирование без согласия
          правообладателя не допускается, кроме случаев личного некоммерческого использования.
        </p>

        <h2>5. Ответственность</h2>
        <p>
          5.1. Сервис не отвечает за решения банков и компаний, а также за изменение их условий после публикации
          на сайте.
        </p>
        <p>
          5.2. Пользователь самостоятельно оценивает риски и принимает решение об оформлении продукта.
        </p>

        <h2>6. Изменения условий</h2>
        <p>
          6.1. Соглашение может обновляться. Продолжение использования сайта означает принятие актуальной версии.
        </p>
      </article>

        <section className="content-banner">
          <div>
            <h2>Смотрите также</h2>
            <p>Политика конфиденциальности и FAQ сервиса.</p>
          </div>
          <div className="content-banner__actions">
            <Link to="/privacy" className="btn btn--primary">
              Политика
            </Link>
            <Link to="/faq" className="btn btn--secondary">
              FAQ
            </Link>
          </div>
        </section>
    </div>
  </main>
);

export default Terms;
